import { DataGrid, GridColDef, GridCsvExportMenuItem, GridToolbarContainer, GridToolbarContainerProps, GridToolbarExportContainer } from '@mui/x-data-grid';
import { GridCsvExportOptions } from '@mui/x-data-grid';
import { Box, ButtonProps, styled, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { landLordToFieldMapping } from '../../slices/serviceagreements.slice';
import { RootState } from '../../store';

const columns: GridColDef[] = [
  { field: 'landLordName', headerName: 'Landlord Name', width: 200, headerAlign: 'center', align: 'center'},
  { field: 'fieldName', headerName: 'Field Name', width: 200, headerAlign: 'center' , align:'center' },
];
const paginationModel = { page: 5, pageSize: 25 };
const csvOptions: GridCsvExportOptions = { delimiter: ';' };

function CustomExportButton(props: ButtonProps) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
    </GridToolbarExportContainer>
  );
}

function CustomToolbar(props: GridToolbarContainerProps) {
  return (
    <GridToolbarContainer {...props}>
      <CustomExportButton />
    </GridToolbarContainer>
  );
}

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .no-rows-primary': {
    fill: '#3D4751',
    ...theme.applyStyles('light', {
      fill: '#AEB8C2',
    }),
  },
  '& .no-rows-secondary': {
    fill: '#1D2126',
    ...theme.applyStyles('light', {
      fill: '#E8EAED',
    }),
  },
}));

function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <Box sx={{ mt: 2 }}>No rows</Box>
    </StyledGridOverlay>
  );
}
const LandlordDataTable: React.FC = () => {
const dispatch = useAppDispatch();
const { fieldMappingArray } = useAppSelector((state: RootState) => state.serviceagreements);

useEffect(() => {
   dispatch(landLordToFieldMapping());
},[]);
  return (
    <Box sx={{ height: 590, width: '100%',  '& .super-app-theme--header': {
        backgroundColor: 'rgba(241, 239, 239, 0.94)',
      }, }}>
        <Typography variant='h6' color='primary' sx={{flex:1}}>Landlord Field Mapping</Typography>
          <DataGrid
           sx={{
            boxShadow: 2,
            border: 2,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
          }}
              rows={fieldMappingArray}
              columns={columns}
              initialState={{ pagination: { paginationModel },  }}
              pageSizeOptions={[20, 3]}
              slots={{toolbar: CustomToolbar, noRowsOverlay: CustomNoRowsOverlay}}
              />             
      </Box>
  );
}
export default LandlordDataTable;